import React from "react";
import LocalCafeOutlinedIcon from "@mui/icons-material/LocalCafeOutlined";

import {
    Box,
    Typography,
    Grid,
    Divider,
} from "@mui/material";
import GetEBookButton from "./GetEBookButton";

const squareItems = [
    {
        title: "166-Page Guide",
        subtitle: "Science-based insights, stories, and practical exercises.",
    },
    {
        title: "Visual Tools",
        subtitle: "Posters for emotions, strengths, kindness, and growth.",
    },
    {
        title: "Family Activities",
        subtitle: "Gratitude Jar, Treasure Box, and Kindness Challenges.",
    },
    {
        title: "Printables",
        subtitle: "Planner, Reward Chart, and Mother–Child Time posters.",
    },
];

export default function WhatIsIncluded() {
    return (
        <Box
            sx={{
                width: "100vw",
                mx: "auto",
                p: { xs: 2, md: 4 },
                bgcolor: "custom.green",
                borderRadius: 0,
                boxShadow: "none",
                position: "relative",
                left: "50%",
                right: "50%",
                marginLeft: "-50vw",
                marginRight: "-50vw",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <Box sx={{ width: "100%"}}>
                <Typography
                    variant="h4"
                    fontWeight={400}
                    color="text.primary"
                    gutterBottom
                    sx={{ textAlign: "center", mb: 2 }}
                >
                    <strong>Because Peace of Mind Shouldn’t Cost a Fortune</strong>
                </Typography>
                <Typography
                    variant="h6"
                    
                    fontWeight={400}
                    color="text.primary"
                    sx={{ textAlign: "center", mb: 2 }}
                >
                    <strong>
                        For the cost of a few cups of coffee, you can give yourself something priceless
                    </strong>
                </Typography>
                <Typography
                    variant="body1"
                    
                    color="text.secondary"
                    sx={{ textAlign: "center", mb: 2, fontSize: 20 }}
                >
                    Inside <em>Happy US</em>, you’ll find tools that don’t just teach — they transform how you see yourself, your child, and your family.
                </Typography>
                <Divider sx={{ my: 3 }} />
                <Typography
                    variant="h5"
                    
                    fontWeight={700}
                    color="text.primary"
                    sx={{ mb: 2, textAlign: "center" }}
                >
                    <strong>What’s Included:</strong>
                </Typography>
                <Grid container spacing={{ xs: 1, md: 2 }} alignItems="stretch">
                    {squareItems.map((item, idx) => (
                        <Grid item xs={12} sm={6} md={3} key={idx}>
                            {/* Smaller square wrapper */}
                            <Box sx={{ position: 'relative', width: '100%', pt: { xs: '48%', sm: '48%', md: '48%' } }}>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        inset: 0,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 2,
                                        bgcolor: 'background.paper',
                                        p: { xs: 1, md: 1.5 },
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography variant="h6" sx={{ mb: 0.5, fontSize: { xs: 19, md: 22 } }}>
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: 15, md: 17 } }}>
                                        {item.subtitle}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
                <Divider sx={{ my: 3 }} />
                <Typography
                    variant="body1"
                    
                    color="text.primary"
                    sx={{ mb: 2, fontSize: 20, textAlign: "center" }}
                >
                    <strong>
                        That’s exactly what <em>Happy US</em> helps you build
                    </strong>
                    : the simple tools, rituals, and connections that nurture that same warmth and resilience in your child.
                </Typography>
                <Box sx={{ textAlign: "center", mt: 4 }}>
                  <GetEBookButton/>
                </Box>
            </Box>
        </Box>
    );
}